import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';
import { toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';
import { CopyRiskEvaluationInstance, RiskMatrixInstance } from 'app/area/case/components/loss-potential/constants';

export const api = {
  addRiskEvaluationEdit: async (
    draftId: number, 
    riskMatrixInstance: number, 
    instanceCopyCmd: number, 
    initialValues: AddRiskEvaluationInitialValues,
    queryParameters?: {[key:string]: string | number}
    ) => {
    return await new RemoteData(`${endpoint.draft}/${draftId}/riskevaluation`)
      .resource<any>()
      .filter({
        ...queryParameters
      })
      .create({
        riskMatrixInstance,
        instanceCopyCmd,
        validFrom: toISODatewithoutTimezone(initialValues.validFrom)(),
        description: initialValues.description,
        hideInReport: initialValues.hideInReport
      });
  },

  addRiskEvaluationRead: async (
    draftId: number, 
    riskMatrixInstance: number, 
    instanceCopyCmd: number, 
    initialValues: AddRiskEvaluationInitialValues,
    queryParameters?: {[key:string]: string | number},
    copyToResidual?: boolean
    ) => {
    return await new RemoteData(`${endpoint.draft}`)
      .resource<any>()
      .filter({
        ...queryParameters
      })
      .create({
        caseId: draftId,
        riskEvaluationParameters: [{
          riskMatrixInstance,
          instanceCopyCmd,
          validFrom: toISODatewithoutTimezone(initialValues.validFrom)(),
          description: initialValues.description,
          hideInReport: initialValues.hideInReport
        },
        copyToResidual ? {
          riskMatrixInstance: RiskMatrixInstance.ResidualLossPotential,
          instanceCopyCmd: CopyRiskEvaluationInstance.CopyPrevious,
          validFrom: toISODatewithoutTimezone(initialValues.validFrom)(),
          description: initialValues.description,
          hideInReport: initialValues.hideInReport
        } : undefined]
      });
    }
};
